<template>
	<div class="page">
		<el-dialog :visible.sync="showStatus" width="80%">
			<el-form @submit.native.prevent :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
				<el-form-item label="选择供应商">
					<el-input clearable v-model="smNames" :id="9999999"
						@keyup.enter.native="openSearch('155784192757760', 0, 'smName', 'smId,smName')">
						<el-button @click="openSearch('155784192757760', 0, 'smName', 'smId,smName')" slot="append"
							icon="el-icon-search">
						</el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="截止日期">
					<el-date-picker  size="mini" v-model="jzrq" 
					format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="downCode">下载二维码</el-button>
				</el-form-item>
			</el-form>
			<el-table class="mainTable" ref="minTable"
               stripe :data="goodsInfo"
              :height="tableHeight" :key="$store.state.tableNum" border size="mini" style="width: 100%"
              highlight-current-row>
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
              <el-table-column v-if="tableValye.isShow == 1"
                v-for="(tableValye, tableKey) in pageShowData" :key="tableKey"
                :prop="tableValye.entityField" :label="tableValye.showField" :min-width="tableValye.fieldWeight">
                <template slot-scope="scope">
                  <div v-if="tableValye.entityField == 'pspmState'">
                    {{ scope.row.pspmState == 0 ? '初始' : '已转为订单' }}
                  </div>
                  <div v-else-if="tableValye.entityField == 'pspmSdate'">
                    {{ $common.getLocalTime(scope.row[item.props]) }}
                  </div>
                  <div v-else-if="tableValye.fieldType == 'formatter'">
                    <el-tag size="mini" type="primary">{{ $common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField]) }}</el-tag>
                  </div>
                  <div v-else-if="tableValye.entityField == 'lackNum'">
                    <el-input v-if="scope.row.edit" v-model="scope.row.lackNum" @blur="blurUpdate(scope.row)"></el-input>
                    <span v-else>{{ scope.row.lackNum }}</span>
                  </div>
                  <div v-else>
                    {{ scope.row[tableValye.entityField] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>

		</el-dialog>
		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
			<SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth"
				@sendTitle="getSearchName" />
		</el-dialog>
	</div>
</template>
<script>
import {
	getChatRecord,
	getChatManage
} from "@/service/printApi.js";
import SearchScheme from "@/byComponents/SearchScheme.vue";

// @ is an alias to /src
export default {
	components: {
		SearchScheme,
	}
	,
	name: "home",
	data() {
		return {
			smNames: "",
			smId: "",
			seWidth: "500",
			seTitle: "",
			seId: "",
			seIndex: "",
			seType: "",
			sField: "",
			parentSearchData: {
				smId: ""
			},
			goodPriceList: [],
			getRequestData: {},
			DialogVisible: false,
			showStatus: false,
			reSearchData: "",
			requesUrl: this.$store.getters.getConfig.requestUrl,
			imgUrl: this.$store.getters.getConfig.imgUrl,
			goodsInfo:[],
			pageShowData:"",
			returnData:"",
			tableHeight:0,
			jzrq:"",
			
		};
	},

	
	mounted() {

	},
	computed: {},
	watch: {
	},
	methods: {
		openBox(e,pageShowData) {
			this.pageShowData= pageShowData
			this.goodsInfo = e
			this.showStatus = true
			this.jzrq = ""
			// console.log(this.goodsInfo)
			this.reSearchData = ""
			this.smNames = ""
		},
		//检索Id, 索引(表格中), 标识
		openSearch(sId, index, type, sField) {
			console.log(sId, index, type, sField)
			this.DialogVisible = true;
			this.seId = sId;
			this.seIndex = index;
			this.seType = type;
			this.sField = sField;
			this.parentSearchData.smName= this.smNames
		},
		// 赋值字段
		paramValue(val) {
			console.log(val)
			this.reSearchData = val
			this.smNames = val.smName
		},
		changeInputModel(val) {
			if (val != "" || val != undefined) {
				this.DialogVisible = false;
				this.paramValue(val)
			}
		},
		getSeWidth(e) {
			console.log(e);
			this.seWidth = e + "%";
		},
		getSearchName(e) {
			console.log(e);
			this.seTitle = e;
		},
		downCode() {
			if (this.reSearchData == "" || this.reSearchData.smNames == "") return this.$message({type:"error",message:"请选择供应商！"})
			if (this.jzrq == "") return this.$message({type:"error",message:"请选择截止日期！"})
			let pspdId = []
			this.goodsInfo.forEach(item => {
				pspdId.push(item.pspdId)
			})
			console.log(this.jzrq,   this.requesUrl +
				"/goodsInquiry/qrCode?pspdIds=" + pspdId.toString()
				+ "&&smId=" +
				this.reSearchData.smId
				+"&jzrq= " +this.jzrq.toString())
			window.location.href =
				this.requesUrl +
				"/goodsInquiry/qrCode?pspdIds=" + pspdId.toString()
				+ "&&smId=" +
				this.reSearchData.smId
				+"&jzrq=" +this.jzrq.toString()
		}
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {

	},
	//生命周期 - 挂载完成（可以访问DOM元素）

	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() {
		// this.getSaveMenu()
	}, //生命周期 - 更新之前
	updated() {
    this.$nextTick(() => {
      this.tableHeight = this.$common.getTableHeight()
    })
  }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { },
};
</script>

<style>
.page {
	/* width: 1200px; */
	/* height: 500px; */
}
</style>